<ng-template porFeatureAvailability [featureToken]="featureToken">
    @if (visible) {
    <div class="text-align-center">
        <button
            porAddFeature
            class="btn-link button-loading-outer"
            [ngClass]="class"
            [disabled]="loading"
            [style.cursor]="loading ? 'default' : 'pointer'"
            [featureName]="featureName"
            (click)="buttonClick($event)">
            <img class="actions-image" src="{{ uiUrl }}/assets/images/{{ imgUrl }}" porAddFeature featureName="featureName" />
            <label porAddFeature featureName="featureName">{{ label }}</label>
            @if (loading) {
            <div class="button-loading">
                <img src="./assets/images/output-onlinegiftools.gif" alt="" />
            </div>
            }
        </button>
        @if (loading) {
        <div class="button-loading-text">
            <span>{{ 'TryingToLoad' | translate }}</span>
        </div>
        }
    </div>
    }
</ng-template>
